import "unfetch/polyfill"
import * as React from "react"
import {ApolloClient} from "apollo-client"
import {createHttpLink} from "apollo-link-http"
import {InMemoryCache} from "apollo-cache-inmemory"
import {Cusoon} from "./components/Cusoon"
import createBrowserHistory from "history/createBrowserHistory"
import {InitializeSession} from "./components/InitializeSession"
import {ModalStore} from "./actions"
import {ModalState} from "./state"
import {fragmentMatcher} from "./graphql/fragmentMatcher"
import {setContext} from "apollo-link-context"
import {none, Option, some} from "fp-ts/lib/Option"
import * as ReactGA from "react-ga"
import "react-dates/initialize"
import ApolloProvider from "react-apollo/ApolloProvider"
import {mixed} from "./tsutil"

// From https://stackoverflow.com/a/4029123/268083
// Doesn't look like it escapes the cookie name properly but whatever it works for me.
function getCookie(document: Document, name: string): Option<string> {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"))
  return match ? some(match[2]) : none
}

// Presently you don't get a type error from createHttpLink below if you misspell "same-origin" but
// interactive testing reveals that cookies won't be sent in that case.
const credentials = "same-origin"

export const apollo = new ApolloClient({
  link: setContext((request, prevContext) => ({
    headers: {
      ...prevContext.headers,
      // Commenting this out or setting it to something other than the cookie value
      // should result in an "Invalid CSRF token" response from the server.
      "X-CSRF-Token": getCookie(document, "CSRF-Token").getOrElse(""),
    },
  })).concat(
    createHttpLink({
      uri: "/backend/graphql",
      credentials,
    }),
  ),
  cache: new InMemoryCache({fragmentMatcher}),
})

// TODO Migrate the tracking code to cusoon.json and fetch it via GraphQL
ReactGA.initialize("UA-23210090-1")
ReactGA.pageview(window.location.pathname + window.location.search)

export const history = createBrowserHistory()

// noinspection JSUnusedLocalSymbols
history.listen((location, action) => {
  ReactGA.pageview(location.pathname + location.search)
})

export {ModalStore}

export interface WithModalStore {
  modalStore: ModalStore
}

export class App extends React.Component<{}, {modal: ModalState}> {
  modalStore = new ModalStore(
    () => this.state.modal,
    (f) => this.setState(({modal}) => ({modal: f(modal)})),
  )

  constructor(props: {}) {
    super(props)
    this.state = {modal: ModalStore.initialState()}
  }

  componentWillMount() {
    window.addEventListener("error", this.errorListener)
  }

  componentWillUnmount() {
    window.removeEventListener("error", this.errorListener)
  }

  errorListener = (event: ErrorEvent) => {
    this.modalStore.handleError(event.error)
  }

  render() {
    let ret = (
      <InitializeSession>
        <Cusoon history={history} modalStore={this.modalStore} />
      </InitializeSession>
    )

    // We don't actually use the ApolloProvider. It's just here because it is required to be an
    // object by the React Apollo Query component:
    // https://github.com/apollographql/react-apollo/blob/38f07d6b2ed8ca3c7cea2320473a827af70a253b/src/Query.tsx#L127
    // We deliberately provide {} instead of the real and valid ApolloClient we have above to
    // make sure that we don't depend on the ApolloClient being passed via context.
    ret = <ApolloProvider client={{} as ApolloClient<mixed>} children={ret} />

    return ret
  }
}



// WEBPACK FOOTER //
// ./src/App.tsx